<div class="animated fadeIn">
    <div *ngIf="regProm === 'LEADGEN' else noIsLead">
        <div class="header">
            <p>Felicidades haz terminado tu registro</p>
        </div>
        <div class="body text-center">
            <IMG src="https://leadgenios.net/pixel.track?CID=453303&p=img&MerchantReferenceID=" width="1" height="1" border="0" />
            <img src="https://static.monific.com/assets/assets-app/img/icon/img/success_stp.svg" alt="Image STP" class="img">
            <div class="title">¿Qué sigue?</div>
            <div class="message">
                Felicidades, tu cuenta ha sido creada con éxito y se ha asignado tu CLABE a tu cuenta. Ahora podrás realizar depósitos para empezar a invertir.
            </div>
        </div>

        <div class="d-flex justify-content-evenly mb-5">
            <button mat-button type="button" class="" (click)="accept()">Aceptar</button>
        </div>

    </div>
    <ng-template #noIsLead>
        <div class="header">
            <p>Felicidades haz terminado tu registro</p>
        </div>
        <div class="body text-center">
            <img src="https://static.monific.com/assets/assets-app/img/icon/img/success_stp.svg" alt="Image STP" class="img">
            <div class="title">¿Qué sigue?</div>
            <div class="message">
                Felicidades, tu cuenta ha sido creada con éxito y se ha asignado tu CLABE a tu cuenta. Ahora podrás realizar depósitos para empezar a invertir.
            </div>
        </div>

        <div class="d-flex justify-content-evenly mb-5">
            <button mat-button type="button" class="" (click)="accept()">Aceptar</button>
        </div>

    </ng-template>

</div>
